/**
 * Übersetzungen des Workforce-Frontends (Dienstplan, Zeiterfassung, Stundenkonto, Urlaub, Einstellungen).
 *
 * Schlüssel sind die englischen Texte; die Werte stammen unverändert aus dem bisherigen Wörterbuch des
 * ersten Consumers. Sprachen: Deutsch und Englisch (alle Sprachen der Consumer). Schlüssel
 * `staff.time.rule.*` sind die vom Workforce-Backend gelieferten Hinweiskennungen der Zeitprüfung.
 * Ein Produkt darf eine Formulierung überschreiben (Produkt-Wörterbuch kommt nach Shared).
 */
export const workforceDe: Record<string, string> = {
  "January": "Januar",
  "February": "Februar",
  "March": "März",
  "April": "April",
  "May": "Mai",
  "June": "Juni",
  "July": "Juli",
  "August": "August",
  "September": "September",
  "October": "Oktober",
  "November": "November",
  "December": "Dezember",
  "—": "—",
  "Last 3 months": "letzte 3 Monate",
  "hours short": "Std.",
  "Error exporting": "Fehler beim Exportieren",
  "Employee": "Mitarbeiter",
  "Month": "Monat",
  "Opening balance": "Saldo-Vortrag",
  "Difference": "Differenz",
  "Closing balance": "neuer Saldo",
  "Hours for payroll": "Stunden für die Abrechnung",
  "Paid-out hours": "ausgezahlt",
  "Actual hours": "Ist-Stunden",
  "Target hours": "Soll-Stunden",
  "Month closed on": "abgeschlossen am",
  "Hour balance": "Stundenkonto",
  "Hour account statement": "Kontoauszug",
  "Open working time reports": "offene Zeitmeldungen",
  "Close month": "Monat abschließen",
  "Month closed for {count} employees": "Monat für {count} Mitarbeiter abgeschlossen",
  "Overtime": "Überstunden",
  "Vacation days": "Urlaubstage",
  "Sick days": "Krankheitstage",
  "Holiday absence": "Feiertagsabwesenheit",
  "Unresolved days": "ungeklärte Tage",
  "Carried from previous months": "Nachträge aus Vormonaten",
  "Notice": "Hinweis",
  "Pay": "Vergütung",
  "Payroll preparation": "Lohnvorbereitung",
  "Error saving": "Fehler beim Speichern",
  "Export": "exportieren",
  "Staff schedule": "Dienstplan",
  "Unresolved days are days on which working day or public holiday would be answered differently depending on the studio, and no studio of deployment is known. They do not count towards target hours.": "Ungeklärte Tage sind Tage, an denen sich Arbeitstag oder Feiertag je nach Studio unterschiedlich beantworten würde und kein Einsatzstudio feststeht. Sie zählen nicht in die Soll-Stunden.",
  "Affected days": "Betroffene Tage",
  "Set the studio directly on the affected shifts in the staff schedule, or align the studios' holiday calendars.": "Setzen Sie im Dienstplan das Studio direkt an den betroffenen Schichten, oder gleichen Sie die Feiertagskalender der Studios ab.",
  "Mon": "Mo",
  "Tue": "Di",
  "Wed": "Mi",
  "Thu": "Do",
  "Fri": "Fr",
  "Sat": "Sa",
  "Sun": "So",
  "From": "von",
  "Select start date": "Startdatum wählen",
  "Until": "bis",
  "Specify end date": "Ende angeben",
  "End date must not be before start date": "Ende darf nicht vor dem Start liegen",
  "Select end or enter duration": "Ende wählen oder Dauer eingeben",
  "Please select a date range": "Bitte einen Zeitraum wählen",
  "Please select at least one weekday": "Bitte mindestens einen Wochentag wählen",
  "Availability updated": "Verfügbarkeit aktualisiert",
  "Availability created": "Verfügbarkeit erstellt",
  "Absence updated": "Abwesenheit aktualisiert",
  "Absence created": "Abwesenheit erstellt",
  "Absence deleted": "Abwesenheit gelöscht",
  "Error deleting": "Fehler beim Löschen",
  "Availability deleted": "Verfügbarkeit gelöscht",
  "Recorded": "erfasst",
  "Requested": "beantragt",
  "Rejected": "abgelehnt",
  "Absence approved": "genehmigt",
  "Absence type": "Abwesenheitsgrund",
  "Period": "Periode",
  "Note": "Notiz",
  "Weekly": "wöchentlich",
  "Really delete this absence?": "Diese Abwesenheit wirklich löschen?",
  "Really delete this availability?": "Diese Verfügbarkeit wirklich löschen?",
  "Start time": "Startzeit",
  "End time": "Endzeit",
  "End time must be after start time": "Endzeit muss nach Startzeit liegen",
  "Availabilities": "Verfügbarkeiten",
  "New availability": "neue Verfügbarkeit",
  "Absences": "Abwesenheiten",
  "New absence": "neue Abwesenheit",
  "Edit availability": "Verfügbarkeit bearbeiten",
  "Edit absence": "Abwesenheit bearbeiten",
  "Employee is required": "Mitarbeiter ist erforderlich",
  "Absence type is required": "Abwesenheitsgrund ist erforderlich",
  "Only a time window of the day": "nur ein Tageszeitfenster",
  "Recurrence": "Wiederholung",
  "One-time": "einmalig",
  "Daily": "täglich",
  "Monthly": "monatlich",
  "Yearly": "jährlich",
  "Weekdays": "Wochentage",
  "New absence type": "neuer Abwesenheitsgrund",
  "Edit absence type": "Abwesenheitsgrund bearbeiten",
  "Absence type created": "Abwesenheitsgrund erstellt",
  "Absence type updated": "Abwesenheitsgrund aktualisiert",
  "Absence type deleted": "Abwesenheitsgrund gelöscht",
  "Name is required": "Name ist erforderlich",
  "Abbreviation": "Kürzel",
  "Abbreviation is required": "Kürzel ist erforderlich",
  "Color": "Farbe",
  "Category": "Kategorie",
  "Vacation counts against the vacation entitlement, sick leave is counted separately, time off in lieu reduces the hour balance.": "Urlaub zählt gegen den Urlaubsanspruch, Krankheit wird getrennt gezählt, Freizeitausgleich senkt das Stundenkonto.",
  "Other": "Sonstige",
  "Vacation": "Urlaub",
  "Sick leave": "Krankheit",
  "Time off in lieu": "Freizeitausgleich",
  "Calendar resource": "Kalenderressource",
  "Person or pool resource this activity covers in the calendar.": "Personen- oder Pool-Ressource, die diese Tätigkeit im Kalender füllt.",
  "New activity type": "neue Tätigkeit",
  "Edit activity type": "Tätigkeit bearbeiten",
  "Activity type created": "Tätigkeit erstellt",
  "Activity type updated": "Tätigkeit aktualisiert",
  "Activity type deleted": "Tätigkeit gelöscht",
  "Counts as work time": "zählt als Arbeitszeit",
  "Selectable in employee app": "in der Mitarbeiter-App auswählbar",
  "Monday": "Montag",
  "Tuesday": "Dienstag",
  "Wednesday": "Mittwoch",
  "Thursday": "Donnerstag",
  "Friday": "Freitag",
  "Saturday": "Samstag",
  "Sunday": "Sonntag",
  "all day": "ganztägig",
  "Date range": "Datumsbereich",
  "Weekly availability": "wöchentlich",
  "Availability type": "Art der Verfügbarkeit",
  "Weekday": "Wochentag",
  "Select weekday": "Wochentag auswählen",
  "Valid from": "gültig ab",
  "Valid until": "gültig bis",
  "Available all day": "ganztägig verfügbar",
  "Add availability": "Verfügbarkeit hinzufügen",
  "Delete availability": "Verfügbarkeit löschen",
  "Error loading": "Fehler beim Laden",
  "Availabilities updated": "Verfügbarkeiten aktualisiert",
  "No availability restrictions": "Keine Einschränkungen",
  "{count} availability rules": "{count} Verfügbarkeitsregeln",
  "Edit availabilities": "Verfügbarkeiten bearbeiten",
  "Availability rules define when this employee can be scheduled. Without rules, scheduling is unrestricted.": "Die Verfügbarkeiten legen fest, wann dieser Mitarbeiter eingeplant werden kann. Ohne Einträge ist die Planung uneingeschränkt.",
  "This employee has legacy recurrence rules that cannot be edited in the new structure.": "Dieser Mitarbeiter hat alte Wiederholungsregeln, die in der neuen Struktur nicht bearbeitet werden können.",
  "Remove old monthly and yearly rules when saving": "Alte monatliche und jährliche Regeln beim Speichern entfernen",
  "Plan staff shifts week by week": "Schichten wochenweise planen",
  "Manage staff absences (vacation, sick, …)": "Abwesenheiten verwalten (Urlaub, Krankheit, …)",
  "Manage staff availabilities": "Verfügbarkeiten von Mitarbeitern verwalten",
  "Vacation management": "Urlaubsverwaltung",
  "Annual entitlement and remaining vacation per employee": "Jahresanspruch und Resturlaub je Mitarbeiter",
  "Working time": "Arbeitszeit",
  "Reported working time and approvals": "gemeldete Arbeitszeiten und Freigaben",
  "Monthly hours overview per employee with export": "Monats-Stundenübersicht je Mitarbeiter mit Export",
  "Closed months of the hour account with export": "abgeschlossene Monate des Stundenkontos zum Herunterladen",
  "Staff": "Personal",
  "No permissions available": "keine Berechtigungen verfügbar",
  "Saved": "gespeichert",
  "The month is already closed. Book the correction in the current month.": "Der Monat ist bereits abgeschlossen. Erfasse die Korrektur im laufenden Monat.",
  "Opening hour balance": "Eröffnungssaldo",
  "Hours (negative to pay out)": "Stunden (negativ bei Auszahlung)",
  "Balance (history)": "Saldo",
  "Hour account history": "Verlauf",
  "Loading history...": "Historie wird geladen …",
  "No closed months yet.": "noch kein abgeschlossener Monat",
  "debited (past)": "abgebucht",
  "credited (past)": "aufgebucht",
  "Each step needs its own threshold.": "Jede Stufe braucht eine eigene Schwelle.",
  "Disable minimum wage?": "Mindestlohn deaktivieren?",
  "Disable minimum wage confirmation content": "{count} Mitarbeiter nutzen aktuell den Mindestlohn. Wenn Sie den Mindestlohn deaktivieren, wird der aktuelle Satz ({rate}) als fester Stundenlohn bzw. als Monatsgehalt hinterlegt und die Mindestlohn-Option entfernt. Möchten Sie fortfahren?",
  "Apply and disable": "Übernehmen und deaktivieren",
  "Error loading data": "Fehler beim Laden der Daten",
  "Time tracking": "Zeiterfassung",
  "Record working time": "Arbeitszeit erfassen",
  "Employees only report corrections; otherwise the schedule counts.": "Mitarbeiter melden nur Korrekturen; ansonsten gilt der Dienstplan.",
  "Employees confirm the complete workday once; corrections continue to use the same process.": "Mitarbeiter bestätigen den gesamten Arbeitstag einmal; Korrekturen laufen weiterhin über denselben Ablauf.",
  "Apply break rule to calculation": "Pausenvorgabe rechnerisch anwenden",
  "Used only when no actual break duration was reported; it is not proof of a taken break.": "Gilt nur, wenn keine tatsächliche Pausendauer gemeldet wurde; sie ist kein Nachweis einer genommenen Pause.",
  "Add step": "Stufe zufügen",
  "No steps — nothing is deducted.": "Keine Stufe — es wird nichts abgezogen.",
  "Remove step": "Stufe entfernen",
  "From working time": "ab Arbeitszeit",
  "Break": "Pause",
  "minutes short": "Min.",
  "HR and payroll master data": "Personalwesen",
  "Maintain HR and payroll master data": "Personalwesen führen",
  "Shows vacation accounts, payroll preparation and tax/social-insurance fields.": "Blendet Urlaubskonto und Abrechnungsvorbereitung ein.",
  "Use minimum wage": "Mindestlohn verwenden",
  "Allows managing central minimum wage rates and selecting minimum wage in employee master data.": "Ermöglicht zentrale Mindestlohnsätze und die Mindestlohn-Auswahl in den Personal-Stammdaten.",
  "Employee app shift visibility": "Schichtsichtbarkeit in der Mitarbeiter-App",
  "All employees may see all shifts": "Alle Mitarbeiter dürfen alle Schichten sehen",
  "Employees who may see all shifts": "Mitarbeiter, die alle Schichten sehen dürfen",
  "Minimum wage rate saved": "Mindestlohn-Satz gespeichert",
  "Deleted": "gelöscht",
  "Hourly wage": "Stundenlohn",
  "open-ended": "offen",
  "Really delete this rate?": "Diesen Satz wirklich löschen?",
  "New minimum wage rate": "neuer Mindestlohn-Satz",
  "Edit minimum wage rate": "Mindestlohn-Satz bearbeiten",
  "Pay out overtime": "Plusstunden auszahlen",
  "Pay overtime up to the mini-job limit": "bis zur Geringfügigkeitsgrenze auszahlen",
  "Collect overtime": "Plusstunden sammeln",
  "Profile saved": "Stammdaten gespeichert",
  "Last name": "Nachname",
  "First name": "Vorname",
  "Annual vacation days": "Jahres-Urlaubsanspruch",
  "Run payroll": "Abrechnung führen",
  "Weekly target hours": "Wochen-Sollstunden",
  "Work days per week": "Tage pro Woche",
  "Employment start": "Beschäftigungsbeginn",
  "Employment end": "Beschäftigungsende",
  "No": "Nein",
  "Yes": "Ja",
  "Edit employee master data": "Mitarbeiter bearbeiten",
  "5-day week": "5-Tage-Woche",
  "6-day week": "6-Tage-Woche",
  "Without payroll this employee stays in the schedule but is left out of payroll preparation and the hour balance.": "Ohne Abrechnung bleibt der Mitarbeiter im Dienstplan, erscheint aber nicht in der Abrechnungsvorbereitung und bekommt kein Stundenkonto.",
  "Pay model": "Lohnmodell",
  "Monthly salary": "Monatsgehalt",
  "Always use the central minimum wage instead of an individual rate": "immer den zentralen Mindestlohn statt eines individuellen Satzes verwenden",
  "days short": "Tage",
  "Please select another studio scope": "Bitte einen anderen Studio-Geltungsbereich wählen",
  "Schedule settings saved": "Dienstplan gespeichert",
  "Schedule settings deleted": "Dienstplan gelöscht",
  "Studios": "Studios",
  "Grid start": "Rasterbeginn",
  "Grid end": "Rasterende",
  "Grid resolution": "Rasterauflösung",
  "Planning advance period (days)": "Vorlauf (Tage)",
  "Working days": "Arbeitstage",
  "Allow booking against default plan": "Terminbuchung auf Basis des Standardplans erlauben",
  "Delete schedule settings?": "Dienstplan löschen?",
  "Schedule settings delete confirmation": "Dieser Dienstplan wird gelöscht.",
  "Add schedule settings": "Dienstplan hinzufügen",
  "Edit schedule settings": "Dienstplan bearbeiten",
  "Duplicate schedule settings": "Dienstplan duplizieren",
  "Empty = for all studios. Multiple selection.": "Leer = für alle Studios. Mehrere wählbar.",
  "Working time approved": "Arbeitszeit freigegeben",
  "Pending": "ausstehend",
  "not worked": "nicht gearbeitet",
  "Approved": "freigegeben",
  "Approve": "freigeben",
  "Correct and approve": "korrigieren und freigeben",
  "Closed": "abgeschlossen",
  "Please select a studio": "Bitte ein Studio wählen",
  "Share link saved": "Link gespeichert",
  "Share link created": "Link erstellt",
  "Share link deleted": "Link gelöscht",
  "All studios": "alle Studios",
  "Studio": "Studio",
  "Copied to clipboard": "In die Zwischenablage kopiert",
  "Copy failed": "Fehler beim Kopieren.",
  "Really delete this share link?": "Diesen Link wirklich löschen?",
  "Create share link": "Link erstellen",
  "Edit share link": "Link bearbeiten",
  "Empty = all studios.": "Leer = alle Studios.",
  "(all studios)": "(alle Studios)",
  "Vacation entitlement saved": "Urlaubsanspruch gespeichert",
  "Annual entitlement": "Jahresanspruch",
  "Carry-over": "Übertrag",
  "Taken": "genommen",
  "Planned vacation": "geplanter Urlaub",
  "Remaining vacation": "Resturlaub",
  "Vacation is tracked from {year}.": "Der Urlaub wird ab {year} geführt.",
  "Year": "Jahr",
  "Edit vacation entitlement": "Urlaubsanspruch bearbeiten",
  "Values for this year": "Werte für dieses Jahr",
  "Differing annual entitlement": "abweichender Jahresanspruch",
  "Leave empty to use the general entitlement — only enter a value if it differs for this year (e.g. pro rata in the year of joining).": "Leer lassen = genereller Anspruch gilt. Nur ausfüllen, wenn er für dieses Jahr abweicht (z. B. anteilig im Eintrittsjahr).",
  "Carry-over from": "Übertrag aus",
  "Leave empty for automatic carry-over from the previous year": "Leer lassen für automatischen Übertrag aus dem Vorjahr",
  "Working time corrected and approved": "Arbeitszeit korrigiert und freigegeben",
  "A report from a closed month cannot be corrected and approved directly.": "Eine Meldung aus einem abgeschlossenen Monat kann nicht direkt korrigiert und freigegeben werden.",
  "This month is closed. The entry is appended and settled in the current month.": "Der Monat ist abgeschlossen. Die Meldung wird ergänzt und im laufenden Monat verrechnet.",
  "Day": "Tag",
  "Planned": "Plan",
  "Actual": "Ist",
  "Reason": "Grund",
  "As planned": "nach Plan",
  "Absence": "Abwesenheit",
  "Month closed": "Monat abgeschlossen",
  "Deviations only": "nur Abweichungen",
  "Time record": "Stundennachweis",
  "Edit working time": "Arbeitszeit ändern",
  "Report working time": "Arbeitszeit melden",
  "Activity blocks": "Tätigkeitsblöcke",
  "Start": "Start",
  "End": "Ende",
  "Activity": "Tätigkeit",
  "Add activity": "Tätigkeit hinzufügen",
  "Break in minutes": "Pause in Minuten",
  "Correction reason": "Korrekturgrund",
  "Reason is required": "Begründung erforderlich",
  "Document why the reported value was corrected.": "Dokumentiere, warum der gemeldete Wert korrigiert wurde.",
  "For a change: why it was different. For added time: what was done.": "Bei einer Änderung: warum es anders war. Bei zusätzlicher Zeit: was gearbeitet wurde.",
  "Change history": "Änderungshistorie",
  "No entries": "keine Einträge",
  "staff.time.rule.dailyHoursExceeded": "über 10 Stunden am Tag",
  "staff.time.rule.breakTooShort": "Pause zu kurz",
  "staff.time.rule.restPeriodTooShort": "Ruhezeit unter 11 Stunden",
  "staff.time.rule.weeklyHoursExceeded": "über 48 Stunden in der Woche",
  "staff.time.rule.belowMinimumWage": "rechnerisch unter Mindestlohn",
  "staff.time.rule.marginalEmploymentLimitExceeded": "über der Geringfügigkeitsgrenze",
  "Require daily confirmation in the employee app": "Tagesbestätigung in der Mitarbeiter-App verlangen",
  "Target": "Ziel",
  "Select activity": "Tätigkeit wählen",
  "End must be after start": "Ende muss nach Beginn liegen",
  "No entries yet.": "Noch keine Einträge.",
  "Default (for all weeks)": "Standard (für alle Wochen)",
  "Week": "Woche",
  "This time is already booked in another studio.": "Diese Zeit ist in einem anderen Studio bereits belegt.",
  "Day copied – choose „Paste“ on target day": "Tag kopiert – wählen Sie „einfügen“ beim Zieltag",
  "Day pasted": "Tag eingefügt",
  "Employee is not assigned to this studio": "Mitarbeiter ist diesem Studio nicht zugeordnet",
  "Remove time unit (click) or drag to remove span": "Zeiteinheit entfernen (klicken) oder Zeitspanne ziehen",
  "Add time unit (click) or drag to add span": "Zeiteinheit hinzufügen (klicken) oder Zeitspanne ziehen",
  "Copy day (then choose „Paste“ on target day)": "Tag kopieren (dann bei Zieltag „einfügen“ wählen)",
  "Paste here": "Hier einfügen",
  "Previous day": "vorheriger Tag",
  "Previous month": "vorheriger Monat",
  "Previous week": "vorherige Woche",
  "Next day": "nächster Tag",
  "Next month": "nächster Monat",
  "Next week": "nächste Woche",
  "Today": "heute",
  "Holidays": "Feiertage",
  "Unsaved changes": "ungespeicherte Änderungen",
  "Save or discard changes?": "Vorher speichern oder Änderungen verwerfen?",
  "Discard": "verwerfen",
  "Please create an activity type first": "Bitte zuerst eine Tätigkeit anlegen",
  "This time range overlaps an existing entry.": "Dieser Zeitraum überschneidet sich mit einem bestehenden Eintrag.",
  "Employee is already scheduled in another studio at this time.": "Mitarbeiter ist zu dieser Zeit bereits in einem anderen Studio verplant.",
  "Week published": "Woche veröffentlicht",
  "Week publication withdrawn": "Veröffentlichung zurückgenommen",
  "Please select at least one studio and one employee for source.": "Bitte wählen Sie mindestens ein Studio und einen Mitarbeiter als Quelle.",
  "Please select at least one studio and one employee for target.": "Bitte wählen Sie mindestens ein Studio und einen Mitarbeiter als Ziel.",
  "Source and target must have the same number of studios and employees.": "Quelle und Ziel müssen gleich viele Studios und Mitarbeiter haben.",
  "Select week": "Woche auswählen",
  "Copied from {0} to {1}.": "Von {0} nach {1} kopiert.",
  "List": "Liste",
  "Employees": "Mitarbeiter",
  "(all employees)": "(alle Mitarbeiter)",
  "Hide employees who do not usually work here": "Mitarbeiter ohne Einsatz hier in den letzten 4 Wochen ausblenden",
  "Show employees who do not usually work here": "alle Mitarbeiter einblenden",
  "published": "veröffentlicht",
  "Save failed": "Fehler beim Speichern",
  "Add entry": "Eintrag hinzufügen",
  "blocks": "Blöcke",
  "day": "Tag",
  "All employees are hidden because none of them worked here recently.": "Alle Mitarbeiter sind ausgeblendet, weil keiner von ihnen in den letzten 4 Wochen hier im Einsatz war.",
  "No employees for this studio": "keine Mitarbeiter für dieses Studio",
  "Copy shifts": "Schichten kopieren",
  "Select studios...": "Studios wählen…",
  "Weeks": "Wochen",
  "Copy is 1:1 by order: first source studio → first target studio, first source employee → first target employee, etc.": "Kopie erfolgt 1:1 nach Reihenfolge: erstes Quell-Studio → erstes Ziel-Studio, erster Quell-Mitarbeiter → erster Ziel-Mitarbeiter usw.",
  "Shifts will be copied to {0} week(s).": "Schichten werden auf {0} Wochen kopiert.",
  "Appointments without staff coverage": "Termine ohne Personal-Deckung",
  "Understood": "verstanden",
  "These already booked appointments no longer have staff coverage after this schedule change. Please rebook, reassign, or cancel them manually.": "Diese bereits gebuchten Termine haben nach dieser Dienstplan-Änderung keine Personal-Deckung mehr. Bitte manuell umbuchen, anderem Mitarbeiter zuordnen oder absagen.",
  "Appointment": "Termin",
  "No data": "keine Daten",
  "Copy week": "Woche kopieren",
  "Suggest week": "Woche vorschlagen",
  "Please select a week first": "Bitte zuerst eine Woche wählen",
  "Suggested week": "Vorschlag für die Woche",
  "Apply": "übernehmen",
  "Assigned shifts: {0}, open: {1}": "eingeteilte Dienste: {0}, offen: {1}",
  "{0} open": "{0} offen",
  "open": "offen",
  "Usually works at this time": "arbeitet üblicherweise zu dieser Zeit",
  "Still needs hours this week": "braucht diese Woche noch Stunden",
  "Would like to work at this time": "wünscht sich diese Zeit",
  "Staff is missing here, so from another studio": "hier fehlt Personal, daher aus einem anderen Studio",
  "Is available": "ist verfügbar",
  "Follows the shift directly": "schließt direkt an den Dienst an",
  "Nobody is assigned to this activity": "niemand für diese Tätigkeit vorgesehen",
  "Nobody is available": "niemand verfügbar",
  "Everyone has reached their working-time limits": "alle haben ihre Arbeitszeitgrenzen erreicht",
  "Not planned because no weekly hours are set: {0}": "nicht eingeplant, weil keine Wochenstunden hinterlegt sind: {0}",
  "Hours balance counted as 0 because no opening balance is entered: {0}": "Stundenstand mit 0 gerechnet, weil kein Anfangsstand eingetragen ist: {0}",
  "No usual staffing yet, please plan by hand once: {0}": "noch keine übliche Besetzung, bitte einmal von Hand planen: {0}",
  "Already published, stays unchanged: {0}": "bereits veröffentlicht, bleibt unverändert: {0}",
  "Nothing to do: all usual shifts of this week are filled.": "nichts zu tun: alle üblichen Dienste dieser Woche sind besetzt.",
  "This week has changed in the meantime. Please suggest it again.": "Die Woche hat sich inzwischen geändert. Bitte neu vorschlagen.",
  "Could not create the suggestion": "Der Vorschlag konnte nicht erstellt werden",
  "Suggestion applied": "Vorschlag übernommen",
  "Open shifts: {0}": "offene Dienste: {0}",
  "show": "anzeigen",
  "Check working time": "Arbeitszeit prüfen",
  "Planning rules": "Planungsregeln",
  "Optional rules for the suggested week": "optionale Regeln für den Wochenvorschlag",
  "People": "Personen",
  "Usual staffing": "übliche Besetzung",
  "Rules": "Regeln",
  "no rule": "keine Regel",
  "not set": "nicht hinterlegt",
  "Add rule": "Regel hinzufügen",
  "Rule template": "Regelvorlage",
  "Remove rule": "Regel entfernen",
  "Home studio": "Stammstudio",
  "Weekly rhythm": "Wochenrhythmus",
  "Same times every week": "jede Woche zu denselben Zeiten",
  "Alternates early and late": "wechselt zwischen früh und spät",
  "Mini-job": "Minijob",
  "Mini-job: stay within the monthly limit": "Minijob: Monatsgrenze einhalten",
  "Only these activities": "nur diese Tätigkeiten",
  "Time wishes": "Zeitwünsche",
  "Time wishes: {0}": "Zeitwünsche: {0}",
  "Agreements: {0}": "Absprachen: {0}",
  "edit agreements": "Absprachen bearbeiten",
  "Add time wish": "Zeitwunsch hinzufügen",
  "Wish": "Wunsch",
  "prefers": "bevorzugt",
  "rather not": "lieber nicht",
  "Taken from the last weeks automatically.": "automatisch aus den letzten Wochen übernommen.",
  "No usual staffing yet, please plan by hand once.": "noch keine übliche Besetzung, bitte einmal von Hand planen.",
  "back to automatic": "zurück zu automatisch",
  "adjust": "anpassen",
  "Add shift": "Dienst hinzufügen",
  "Remove shift": "Dienst entfernen",
  "No scheduled shifts": "keine geplanten Schichten",
  "Calendar week": "Kalenderwoche",
  "Link not found or disabled": "Link nicht gefunden oder deaktiviert",
  "No employees": "keine Mitarbeiter",
  "Allow booking against default plan hint": "Solange für eine Woche kein expliziter oder bestätigter Dienstplan vorliegt, können Termine trotzdem gegen den Standardplan gebucht werden. Wird das ausgeschaltet, werden für Wochen ohne finalen Dienstplan keine buchbaren Termine mehr angeboten.",
};

export const workforceEn: Record<string, string> = {
  "January": "January",
  "February": "February",
  "March": "March",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "August": "August",
  "September": "September",
  "October": "October",
  "November": "November",
  "December": "December",
  "—": "—",
  "Last 3 months": "Last 3 months",
  "hours short": "hrs",
  "Error exporting": "Error exporting",
  "Employee": "Employee",
  "Month": "Month",
  "Opening balance": "Opening balance",
  "Difference": "Difference",
  "Closing balance": "Closing balance",
  "Hours for payroll": "Hours for payroll",
  "Paid-out hours": "Paid out",
  "Actual hours": "Actual hours",
  "Target hours": "Target hours",
  "Month closed on": "Closed on",
  "Hour balance": "Hour balance",
  "Hour account statement": "Hour statement",
  "Open working time reports": "Open working time reports",
  "Close month": "Close month",
  "Month closed for {count} employees": "Month closed for {count} employees",
  "Overtime": "Overtime",
  "Vacation days": "Vacation days",
  "Sick days": "Sick days",
  "Holiday absence": "Holiday absence",
  "Unresolved days": "Unresolved days",
  "Carried from previous months": "Carried from previous months",
  "Notice": "Notice",
  "Pay": "Pay",
  "Payroll preparation": "Payroll preparation",
  "Error saving": "Error saving",
  "Export": "Export",
  "Staff schedule": "Staff scheduling",
  "Unresolved days are days on which working day or public holiday would be answered differently depending on the studio, and no studio of deployment is known. They do not count towards target hours.": "Unresolved days are days on which working day or public holiday would be answered differently depending on the studio, and no studio of deployment is known. They do not count towards target hours.",
  "Affected days": "Affected days",
  "Set the studio directly on the affected shifts in the staff schedule, or align the studios' holiday calendars.": "Set the studio directly on the affected shifts in the staff schedule, or align the studios' holiday calendars.",
  "Mon": "Mon",
  "Tue": "Tue",
  "Wed": "Wed",
  "Thu": "Thu",
  "Fri": "Fri",
  "Sat": "Sat",
  "Sun": "Sun",
  "From": "From",
  "Select start date": "Select start date",
  "Until": "Until",
  "Specify end date": "Specify end date",
  "End date must not be before start date": "End date must not be before start date",
  "Select end or enter duration": "Select end or enter duration",
  "Please select a date range": "Please select a date range",
  "Please select at least one weekday": "Please select at least one weekday",
  "Availability updated": "Availability updated",
  "Availability created": "Availability created",
  "Absence updated": "Absence updated",
  "Absence created": "Absence created",
  "Absence deleted": "Absence deleted",
  "Error deleting": "Error deleting",
  "Availability deleted": "Availability deleted",
  "Recorded": "Recorded",
  "Requested": "Requested",
  "Rejected": "Rejected",
  "Absence approved": "Approved",
  "Absence type": "Absence type",
  "Period": "Period",
  "Note": "Note",
  "Weekly": "Weekly",
  "Really delete this absence?": "Really delete this absence?",
  "Really delete this availability?": "Really delete this availability?",
  "Start time": "Start time",
  "End time": "End time",
  "End time must be after start time": "End time must be after start time",
  "Availabilities": "Availabilities",
  "New availability": "New availability",
  "Absences": "Absences",
  "New absence": "New absence",
  "Edit availability": "Edit availability",
  "Edit absence": "Edit absence",
  "Employee is required": "Employee is required",
  "Absence type is required": "Absence type is required",
  "Only a time window of the day": "Only a time window of the day",
  "Recurrence": "Recurrence",
  "One-time": "One-time",
  "Daily": "Daily",
  "Monthly": "Monthly",
  "Yearly": "Yearly",
  "Weekdays": "Weekdays",
  "New absence type": "New absence type",
  "Edit absence type": "Edit absence type",
  "Absence type created": "Absence type created",
  "Absence type updated": "Absence type updated",
  "Absence type deleted": "Absence type deleted",
  "Name is required": "Name is required",
  "Abbreviation": "Abbreviation",
  "Abbreviation is required": "Abbreviation is required",
  "Color": "Color",
  "Category": "Category",
  "Vacation counts against the vacation entitlement, sick leave is counted separately, time off in lieu reduces the hour balance.": "Vacation counts against the vacation entitlement, sick leave is counted separately, time off in lieu reduces the hour balance.",
  "Other": "Other",
  "Vacation": "Vacation",
  "Sick leave": "Sick leave",
  "Time off in lieu": "Time off in lieu",
  "Calendar resource": "Calendar resource",
  "Person or pool resource this activity covers in the calendar.": "Person or pool resource this activity covers in the calendar.",
  "New activity type": "New activity type",
  "Edit activity type": "Edit activity type",
  "Activity type created": "Activity type created",
  "Activity type updated": "Activity type updated",
  "Activity type deleted": "Activity type deleted",
  "Counts as work time": "Counts as work time",
  "Selectable in employee app": "selectable in employee app",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "all day": "all day",
  "Date range": "date range",
  "Weekly availability": "weekly",
  "Availability type": "Availability type",
  "Weekday": "Weekday",
  "Select weekday": "Select weekday",
  "Valid from": "Valid from",
  "Valid until": "Valid until",
  "Available all day": "available all day",
  "Add availability": "Add availability",
  "Delete availability": "Delete availability",
  "Error loading": "Error loading",
  "Availabilities updated": "Availabilities updated",
  "No availability restrictions": "No restrictions",
  "{count} availability rules": "{count} availability rules",
  "Edit availabilities": "Edit availabilities",
  "Availability rules define when this employee can be scheduled. Without rules, scheduling is unrestricted.": "Availability rules define when this employee can be scheduled. Without rules, scheduling is unrestricted.",
  "This employee has legacy recurrence rules that cannot be edited in the new structure.": "This employee has legacy recurrence rules that cannot be edited in the new structure.",
  "Remove old monthly and yearly rules when saving": "Remove old monthly and yearly rules when saving",
  "Plan staff shifts week by week": "Plan staff shifts week by week",
  "Manage staff absences (vacation, sick, …)": "Manage staff absences (vacation, sick, …)",
  "Manage staff availabilities": "Manage staff availabilities",
  "Vacation management": "Vacation management",
  "Annual entitlement and remaining vacation per employee": "Annual entitlement and remaining vacation per employee",
  "Working time": "Working time",
  "Reported working time and approvals": "Reported working time and approvals",
  "Monthly hours overview per employee with export": "Monthly hours overview per employee with export",
  "Closed months of the hour account with export": "Closed months of the hour account with download",
  "Staff": "Staff",
  "No permissions available": "No permissions available",
  "Saved": "Saved",
  "The month is already closed. Book the correction in the current month.": "The month is already closed. Enter the correction in the current month.",
  "Opening hour balance": "Opening hour balance",
  "Hours (negative to pay out)": "Hours (negative to pay out)",
  "Balance (history)": "balance",
  "Hour account history": "History",
  "Loading history...": "Loading history...",
  "No closed months yet.": "No closed months yet.",
  "debited (past)": "debited",
  "credited (past)": "credited",
  "Each step needs its own threshold.": "Each step needs its own threshold.",
  "Disable minimum wage?": "Disable minimum wage?",
  "Disable minimum wage confirmation content": "{count} employees currently have minimum wage assigned. If you disable minimum wage, the current rate ({rate}) will be stored as their fixed hourly wage or monthly salary and the option will be removed. Do you want to proceed?",
  "Apply and disable": "Apply and disable",
  "Error loading data": "Error loading data",
  "Time tracking": "Time tracking",
  "Record working time": "Record working time",
  "Employees only report corrections; otherwise the schedule counts.": "Employees only report corrections; otherwise the schedule counts.",
  "Employees confirm the complete workday once; corrections continue to use the same process.": "Employees confirm the complete workday once; corrections continue to use the same process.",
  "Apply break rule to calculation": "Apply break rule to calculation",
  "Used only when no actual break duration was reported; it is not proof of a taken break.": "Used only when no actual break duration was reported; it is not proof of a taken break.",
  "Add step": "Add step",
  "No steps — nothing is deducted.": "No steps — nothing is deducted.",
  "Remove step": "Remove step",
  "From working time": "From working time",
  "Break": "Break",
  "minutes short": "min",
  "HR and payroll master data": "HR",
  "Maintain HR and payroll master data": "Maintain HR",
  "Shows vacation accounts, payroll preparation and tax/social-insurance fields.": "Shows vacation accounts and payroll preparation.",
  "Use minimum wage": "Use minimum wage",
  "Allows managing central minimum wage rates and selecting minimum wage in employee master data.": "Allows managing central minimum wage rates and selecting minimum wage in employee master data.",
  "Employee app shift visibility": "Employee app shift visibility",
  "All employees may see all shifts": "All employees may see all shifts",
  "Employees who may see all shifts": "Employees who may see all shifts",
  "Minimum wage rate saved": "Minimum wage rate saved",
  "Deleted": "Deleted",
  "Hourly wage": "Hourly wage",
  "open-ended": "open-ended",
  "Really delete this rate?": "Really delete this rate?",
  "New minimum wage rate": "New minimum wage rate",
  "Edit minimum wage rate": "Edit minimum wage rate",
  "Pay out overtime": "Pay out overtime",
  "Pay overtime up to the mini-job limit": "Pay overtime up to the mini-job limit",
  "Collect overtime": "Collect overtime",
  "Profile saved": "Profile saved",
  "Last name": "Last Name",
  "First name": "First name",
  "Annual vacation days": "Annual vacation days",
  "Run payroll": "Run payroll",
  "Weekly target hours": "Weekly target hours",
  "Work days per week": "Work days per week",
  "Employment start": "Employment start",
  "Employment end": "Employment end",
  "No": "No",
  "Yes": "Yes",
  "Edit employee master data": "Edit employee master data",
  "5-day week": "5-day week",
  "6-day week": "6-day week",
  "Without payroll this employee stays in the schedule but is left out of payroll preparation and the hour balance.": "Without payroll this employee stays in the schedule but is left out of payroll preparation and the hour balance.",
  "Pay model": "Pay model",
  "Monthly salary": "Monthly salary",
  "Always use the central minimum wage instead of an individual rate": "Always use the central minimum wage instead of an individual rate",
  "days short": "days",
  "Please select another studio scope": "Please select another studio scope",
  "Schedule settings saved": "Schedule settings saved",
  "Schedule settings deleted": "Schedule settings deleted",
  "Studios": "Studios",
  "Grid start": "Grid start",
  "Grid end": "Grid end",
  "Grid resolution": "Grid resolution",
  "Planning advance period (days)": "Advance period (days)",
  "Working days": "Working days",
  "Allow booking against default plan": "Allow booking against default plan",
  "Delete schedule settings?": "Delete schedule settings?",
  "Schedule settings delete confirmation": "These schedule settings will be deleted.",
  "Add schedule settings": "Add schedule settings",
  "Edit schedule settings": "Edit schedule settings",
  "Duplicate schedule settings": "Duplicate schedule settings",
  "Empty = for all studios. Multiple selection.": "Empty = for all studios. Multiple selection.",
  "Working time approved": "Working time approved",
  "Pending": "Pending",
  "not worked": "not worked",
  "Approved": "Approved",
  "Approve": "Approve",
  "Correct and approve": "Correct and approve",
  "Closed": "Closed",
  "Please select a studio": "Please select a studio",
  "Share link saved": "Share link saved",
  "Share link created": "Share link created",
  "Share link deleted": "Share link deleted",
  "All studios": "all studios",
  "Studio": "Studio",
  "Copied to clipboard": "Copied to clipboard",
  "Copy failed": "Copy failed.",
  "Really delete this share link?": "Really delete this share link?",
  "Create share link": "Create share link",
  "Edit share link": "Edit share link",
  "Empty = all studios.": "Empty = all studios.",
  "(all studios)": "(all studios)",
  "Vacation entitlement saved": "Vacation entitlement saved",
  "Annual entitlement": "Annual entitlement",
  "Carry-over": "Carry-over",
  "Taken": "Taken",
  "Planned vacation": "Planned vacation",
  "Remaining vacation": "Remaining vacation",
  "Vacation is tracked from {year}.": "Vacation is tracked from {year}.",
  "Year": "Year",
  "Edit vacation entitlement": "Edit vacation entitlement",
  "Values for this year": "Values for this year",
  "Differing annual entitlement": "Differing annual entitlement",
  "Leave empty to use the general entitlement — only enter a value if it differs for this year (e.g. pro rata in the year of joining).": "Leave empty to use the general entitlement — only enter a value if it differs for this year (e.g. pro rata in the year of joining).",
  "Carry-over from": "Carry-over from",
  "Leave empty for automatic carry-over from the previous year": "Leave empty for automatic carry-over from the previous year",
  "Working time corrected and approved": "Working time corrected and approved",
  "A report from a closed month cannot be corrected and approved directly.": "A report from a closed month cannot be corrected and approved directly.",
  "This month is closed. The entry is appended and settled in the current month.": "This month is closed. The entry is appended and settled in the current month.",
  "Day": "Day",
  "Planned": "Planned",
  "Actual": "Actual",
  "Reason": "Reason",
  "As planned": "As planned",
  "Absence": "Absence",
  "Month closed": "Month closed",
  "Deviations only": "Deviations only",
  "Time record": "Time record",
  "Edit working time": "Edit working time",
  "Report working time": "Report working time",
  "Activity blocks": "Activity blocks",
  "Start": "Start",
  "End": "End",
  "Activity": "Activity",
  "Add activity": "Add activity",
  "Break in minutes": "Break in minutes",
  "Correction reason": "Correction reason",
  "Reason is required": "A reason is required",
  "Document why the reported value was corrected.": "Document why the reported value was corrected.",
  "For a change: why it was different. For added time: what was done.": "For a change: why it was different. For added time: what was done.",
  "Change history": "Change history",
  "No entries": "No entries",
  "staff.time.rule.dailyHoursExceeded": "More than 10 hours a day",
  "staff.time.rule.breakTooShort": "Break too short",
  "staff.time.rule.restPeriodTooShort": "Rest period below 11 hours",
  "staff.time.rule.weeklyHoursExceeded": "More than 48 hours a week",
  "staff.time.rule.belowMinimumWage": "Effective rate below minimum wage",
  "staff.time.rule.marginalEmploymentLimitExceeded": "Above the marginal employment limit",
  "Require daily confirmation in the employee app": "Require daily confirmation in the employee app",
  "Target": "Target",
  "Select activity": "Select activity",
  "End must be after start": "End must be after start",
  "No entries yet.": "No entries yet.",
  "Default (for all weeks)": "Default (for all weeks)",
  "Week": "Week",
  "This time is already booked in another studio.": "This time is already booked in another studio.",
  "Day copied – choose „Paste“ on target day": "Day copied – choose „Paste“ on target day",
  "Day pasted": "Day pasted",
  "Employee is not assigned to this studio": "Employee is not assigned to this studio",
  "Remove time unit (click) or drag to remove span": "Remove time unit (click) or drag to remove span",
  "Add time unit (click) or drag to add span": "Add time unit (click) or drag to add span",
  "Copy day (then choose „Paste“ on target day)": "Copy day (then choose „Paste“ on target day)",
  "Paste here": "Paste here",
  "Previous day": "Previous day",
  "Previous month": "Previous month",
  "Previous week": "Previous week",
  "Next day": "Next day",
  "Next month": "Next month",
  "Next week": "Next week",
  "Today": "Today",
  "Holidays": "Holidays",
  "Unsaved changes": "Unsaved changes",
  "Save or discard changes?": "Save or discard changes?",
  "Discard": "Discard",
  "Please create an activity type first": "Please create an activity type first",
  "This time range overlaps an existing entry.": "This time range overlaps an existing entry.",
  "Employee is already scheduled in another studio at this time.": "Employee is already scheduled in another studio at this time.",
  "Week published": "Week published",
  "Week publication withdrawn": "Week publication withdrawn",
  "Please select at least one studio and one employee for source.": "Please select at least one studio and one employee for source.",
  "Please select at least one studio and one employee for target.": "Please select at least one studio and one employee for target.",
  "Source and target must have the same number of studios and employees.": "Source and target must have the same number of studios and employees.",
  "Select week": "Select week",
  "Copied from {0} to {1}.": "Copied from {0} to {1}.",
  "List": "List",
  "Employees": "Employees",
  "(all employees)": "(all employees)",
  "Hide employees who do not usually work here": "Hide employees without shifts here in the last 4 weeks",
  "Show employees who do not usually work here": "Show all employees",
  "published": "published",
  "Save failed": "Save failed",
  "Add entry": "Add entry",
  "blocks": "blocks",
  "day": "day",
  "All employees are hidden because none of them worked here recently.": "All employees are hidden because none of them worked here in the last 4 weeks.",
  "No employees for this studio": "No employees for this studio",
  "Copy shifts": "Copy shifts",
  "Select studios...": "Select studios...",
  "Weeks": "Weeks",
  "Copy is 1:1 by order: first source studio → first target studio, first source employee → first target employee, etc.": "Copy is 1:1 by order: first source studio → first target studio, first source employee → first target employee, etc.",
  "Shifts will be copied to {0} week(s).": "Shifts will be copied to {0} week(s).",
  "Appointments without staff coverage": "Appointments without staff coverage",
  "Understood": "Understood",
  "These already booked appointments no longer have staff coverage after this schedule change. Please rebook, reassign, or cancel them manually.": "These already booked appointments no longer have staff coverage after this schedule change. Please rebook, reassign, or cancel them manually.",
  "Appointment": "Appointment",
  "No data": "No data",
  "Copy week": "Copy week",
  "Suggest week": "Suggest week",
  "Please select a week first": "Please select a week first",
  "Suggested week": "Suggested week",
  "Apply": "Apply",
  "Assigned shifts: {0}, open: {1}": "Assigned shifts: {0}, open: {1}",
  "{0} open": "{0} open",
  "open": "open",
  "Usually works at this time": "Usually works at this time",
  "Still needs hours this week": "Still needs hours this week",
  "Would like to work at this time": "Would like to work at this time",
  "Staff is missing here, so from another studio": "Staff is missing here, so from another studio",
  "Is available": "Is available",
  "Follows the shift directly": "Follows the shift directly",
  "Nobody is assigned to this activity": "Nobody is assigned to this activity",
  "Nobody is available": "Nobody is available",
  "Everyone has reached their working-time limits": "Everyone has reached their working-time limits",
  "Not planned because no weekly hours are set: {0}": "Not planned because no weekly hours are set: {0}",
  "Hours balance counted as 0 because no opening balance is entered: {0}": "Hours balance counted as 0 because no opening balance is entered: {0}",
  "No usual staffing yet, please plan by hand once: {0}": "No usual staffing yet, please plan by hand once: {0}",
  "Already published, stays unchanged: {0}": "Already published, stays unchanged: {0}",
  "Nothing to do: all usual shifts of this week are filled.": "Nothing to do: all usual shifts of this week are filled.",
  "This week has changed in the meantime. Please suggest it again.": "This week has changed in the meantime. Please suggest it again.",
  "Could not create the suggestion": "Could not create the suggestion",
  "Suggestion applied": "Suggestion applied",
  "Open shifts: {0}": "Open shifts: {0}",
  "show": "Show",
  "Check working time": "Check working time",
  "Planning rules": "Planning rules",
  "Optional rules for the suggested week": "Optional rules for the suggested week",
  "People": "People",
  "Usual staffing": "Usual staffing",
  "Rules": "Rules",
  "no rule": "No rule",
  "not set": "Not set",
  "Add rule": "Add rule",
  "Rule template": "Rule template",
  "Remove rule": "Remove rule",
  "Home studio": "Home studio",
  "Weekly rhythm": "Weekly rhythm",
  "Same times every week": "Same times every week",
  "Alternates early and late": "Alternates early and late",
  "Mini-job": "Mini-job",
  "Mini-job: stay within the monthly limit": "Mini-job: stay within the monthly limit",
  "Only these activities": "Only these activities",
  "Time wishes": "Time wishes",
  "Time wishes: {0}": "Time wishes: {0}",
  "Agreements: {0}": "Agreements: {0}",
  "edit agreements": "Edit agreements",
  "Add time wish": "Add time wish",
  "Wish": "Wish",
  "prefers": "Prefers",
  "rather not": "Rather not",
  "Taken from the last weeks automatically.": "Taken from the last weeks automatically.",
  "No usual staffing yet, please plan by hand once.": "No usual staffing yet, please plan by hand once.",
  "back to automatic": "Back to automatic",
  "adjust": "Adjust",
  "Add shift": "Add shift",
  "Remove shift": "Remove shift",
  "No scheduled shifts": "No scheduled shifts",
  "Calendar week": "Calendar week",
  "Link not found or disabled": "Link not found or disabled",
  "No employees": "No employees",
  "Allow booking against default plan hint": "While no explicit or confirmed schedule exists for a week, appointments can still be booked against the default plan. Turning this off means no bookable slots are offered for weeks without a final schedule.",
};
